module.exports = __webpack_public_path__ + "static/media/Professional-illustration.d7f03fe8.svg";